import { Box } from '@mui/material';

import { ContactType } from '../types';
import Card from './Card';
import { muiStyles } from './muiStyles';

const Grid = ({
  contacts,
  fetchContacts,
}: {
  contacts: ContactType[];
  fetchContacts: () => Promise<void>;
}) => {
  if (!contacts.length) return <>No Contacts</>;

  return (
    <Box sx={muiStyles.gridContainer}>
      {contacts.map((item) => (
        <Card key={item.zoominfoPersonId} contact={item} fetchContacts={fetchContacts} />
      ))}
    </Box>
  );
};

export default Grid;
